import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

export type CreateWorkflowDTO = {
  name: string;
  access_from: string;
  compute_node_instance_type: string;
  initial_queue_size: number;
  aws_keypair_name: string;
  maintain_initial_size: boolean;
  head_node_instance_type: string;
  max_queue_size: number;
  stack_id: number;
  workflow_owner_password?: string;
  workflow_owner_username: string;
  volume_id: string;
  hostname: string;
  tags: Record<string, string>;
  scheduler_id: number;
  is_gpu: boolean;
  saved_configuration_id?: number;
  saved_configuration_name?: string;
};

export const postWorkflow = async (client: Client, workflow: CreateWorkflowDTO) => {
  return await client(endpoint.workflows, "POST", workflow);
};

export const useCreateWorkflow = () => {
  const { mutate } = useSWRConfig();
  const toastError = useErrorToaster();

  return async (workflow: CreateWorkflowDTO): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await postWorkflow(client, workflow);

      mutate(endpoint.workflows);

      toast.success(`Workflow launched: ${workflow.name}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError(`Failed to launch workflow: ${workflow.name}`, error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);
      }

      return error.response;
    }

    return response;
  };
};
